export default class Table {
  constructor( node ) {
    this.node = node;
    this.handleFreeCells();
  }
  handleFreeCells() {
    let rows = this.node.querySelectorAll( 'tr' );

    for ( let i = 0; i < rows.length; i++ ) {
      let head = rows[ i ].querySelector( 'th' );
      let next = ( i + 1 ) !== rows.length ? rows[ i + 1 ].querySelector( 'th' ) : null;
      if ( head !== null && head.innerHTML === '' && next !== null && next.innerHTML !== '' ) {
        for ( let container of rows[ i ].children ) {
          container.style.borderBottom = '3px solid rgba(0 ,75, 149, 0.2)';
        }
      }
    }
  }
}
